// extracted by mini-css-extract-plugin
export var body = "_l0-0";
export var sectionHeader = "_l0-4";
export var shortcutColumns = "_l0-2";
export var shortcutList = "_l0-1";
export var shortcutSection = "_l0-3";